import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConversationGroup = ({
  bucket,
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      paddingBlock: "200",
      paddingInline: "300",
      "aria-hidden": "true",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-disabled",
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `academy-ai-assistant.drawer.group.${bucket}`
          })
        })
      })
    }), children]
  });
};